import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function CalendarTodayIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon viewBox="0 0 25 25" htmlColor={Color.DetailsInput} {...props}>
      <path d="M5.342 22.225q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.282V7.033q0-.758.525-1.283t1.283-.525h1.385V3.88q0-.33.22-.549a.75.75 0 0 1 .549-.22q.329 0 .549.22t.22.55v1.345h7.577V3.86a.73.73 0 0 1 .215-.535.73.73 0 0 1 .535-.215q.319 0 .534.215a.73.73 0 0 1 .216.535v1.365h1.384q.758 0 1.283.525t.525 1.283v13.384q0 .759-.525 1.283-.525.525-1.283.525zm0-1.5h13.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212v-9.384h-14v9.385q0 .114.096.211a.3.3 0 0 0 .212.096M5.034 9.533h14v-2.5a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H5.342a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212z" />
    </MuiSvgIcon>
  );
}
export default CalendarTodayIcon;
